import React, { useEffect, useState } from 'react'

import { Box, Grid } from '@material-ui/core'
import Tabs from '../../../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../../../components/hooks/BaseTabs/Tab'
import {
  mdiAccountEdit,
  mdiAccountGroup,
  mdiCommentTextMultiple,
  mdiDatabaseEdit,
  mdiFaceAgent,
  mdiFileDocumentEdit,
  mdiPhoneClock,
  mdiWater,
  mdiWrench,
} from '@mdi/js'
import GeneralForm from './Forms/General'
import AttendancesForm from './Forms/Attendances'
import LastAppointmentsForm from './Forms/LastAppointments'
import OrcamentoModel from './Forms/OrcamentoModel'

const Form = ({
  edit = false,
  mutate = {},
  editingId = null,
  readOnly = false,
}) => {
  const [value, setValue] = useState(0)

  return (
    <Box style={{ width: '100%', height: '100%' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Tabs>
            <Tab
              tabIndex={0}
              value={value}
              setValue={setValue}
              icon={mdiDatabaseEdit}
              label="Dados Gerais"
              removeNavigation={false}
            />
            <Tab
              tabIndex={1}
              value={value}
              setValue={setValue}
              icon={mdiAccountGroup}
              label="Técnicos"
              removeNavigation={!edit && true}
            />
            <Tab
              tabIndex={2}
              value={value}
              setValue={setValue}
              icon={mdiFaceAgent}
              label="Ultimos Agendamentos"
              removeNavigation={!edit && true}
            />
            <Tab
              tabIndex={3}
              value={value}
              setValue={setValue}
              icon={mdiFileDocumentEdit}
              label="Modelo Orçamento"
              removeNavigation={!edit && true}
            />
          </Tabs>
        </Grid>

        <Grid item xs={12}>
          {value == 0 && (
            <GeneralForm edit={edit} mutate={mutate} readOnly={readOnly} />
          )}
          {value == 1 && (
            <AttendancesForm
              mutate={mutate}
              editingId={editingId}
              readOnly={readOnly}
            />
          )}
          {value == 2 && <LastAppointmentsForm editingId={editingId} />}
          {value == 3 && <OrcamentoModel editingId={editingId} />}
        </Grid>
      </Grid>
    </Box>
  )
}

export default Form
